export default __webpack_public_path__ + "static/media/badges_icon.0f2ab20b.jpg";